import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import "react-dates/initialize";
import useUniqueId from "../../../Hooks/useUniqueId";
import ActivityItemTypeService from "../../../../Domain/ActivityItemType/ActivityItemType.service";
import useService from "../../../Hooks/useService";
import ActivityService from "../../../../Services/Activity.service";
import DeprecatedSelect from "../../../UI/DeprecatedSelect/DeprecatedSelect";
import VirtualizedAppService from "../../../../Services/VirtualizedApp.service";
export const getItemEventSearchPieceFromTaskFilterState = (state) => {
    if (!state.statuses && !state.apps) {
        return null;
    }
    return {
        activityItemTypeIds: [ActivityItemTypeService.TaskId],
        itemStatusIds: state.statuses && state.statuses.map((status) => status.id),
        virtualizedAppIds: state.apps && state.apps.map((app) => app.id),
    };
};
const TaskFilters = (props) => {
    const makeId = useUniqueId()[1];
    const [itemStatuses, loadItemStatuses] = useService(ActivityService.searchItemStatuses);
    const [apps, loadApps] = useService(VirtualizedAppService.getInternalAppsAndNullOption);
    React.useEffect(() => {
        loadItemStatuses([ActivityItemTypeService.TaskId]);
        loadApps();
    }, [loadApps, loadItemStatuses]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("status"), className: "sr-only", children: "Status" }), _jsx(DeprecatedSelect, { id: makeId("status"), placeholder: "Status", options: itemStatuses.data || [], multi: true, value: props.search.statuses, isLoading: itemStatuses.isLoading, labelKey: "name", valueKey: "id", onChange: (statuses) => props.setSearch((search) => (Object.assign(Object.assign({}, search), { statuses }))) })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("app"), className: "sr-only", children: "App" }), _jsx(DeprecatedSelect, { multi: true, id: makeId("app"), placeholder: "App", options: apps.data || [], value: props.search.apps, isLoading: apps.isLoading, labelKey: "displayName", valueKey: "id", onChange: (app) => props.setSearch((search) => (Object.assign(Object.assign({}, search), { apps: app }))) })] })] }));
};
export default TaskFilters;
